<template>
    <div class="DashboardFilterHeader">
        <Card>
            <div v-if="['client', 'vehicle', 'user'].includes(type)">
                <div class="row">
                    <FormInput v-model="name" label="Search"/>
                    <FormSelect v-model="status" label="Status" nullable>
                        <option value="active">Active</option>
                        <option value="disabled">Disabled</option>
                    </FormSelect>
                </div>
            </div>

            <div v-if="type === 'project'">
                <div class="row">
                    <FormInput v-model="name" label="Search"/>
                    <FormSelectClient v-model="client" nullable/>
                    <FormSelect v-model="status" label="Status" nullable>
                        <option value="active">Active</option>
                        <option value="disabled">Disabled</option>
                    </FormSelect>
                </div>
            </div>

            <div v-if="type === 'ticket'">
                <div class="row">
                    <FormDateInput v-model="startAt" label="Start"/>
                    <FormDateInput v-model="endAt" label="End"/>
                    <FormNumber v-model="ticketNumber" label="Ticket #"/>
                </div>

                <div class="row">
                    <FormSelectClient v-model="client" nullable/>
                    <FormSelectProject v-model="project" nullable/>
                    <FormSelectDriver v-model="driver" nullable/>
                    <FormSelectVehicle v-model="truck" label="Truck" type="trucks" nullable/>
                    <FormSelectVehicle v-model="trailer" label="Trailer" type="trailers" nullable/>
                </div>
            </div>

            <div v-if="type === 'material'">
                <div class="row">
                    <FormInput v-model="name" label="Search"/>
                </div>
            </div>

        </Card>
    </div>
</template>

<script>
import pickBy from 'lodash/pickBy';
import Card from '@/components/Card';

export default {
    name: 'DashboardFilterHeader',

    components: { Card },

    props: {
        type: { type: String, required: true },
    },

    data: () => ({
        name: null, // Search by model name
        status: null,
        startAt: null,
        endAt: null,
        client: null,
        project: null,
        driver: null,
        truck: null,
        trailer: null,
        ticketNumber: null,
    }),

    methods: {
        handleChange() {
            const isStatus = ['active', 'disabled'].includes(this.status);

            const filters = pickBy({
                name: this.name,
                isActive: isStatus ? this.status === 'active' : null,
                startAt: this.startAt,
                endAt: this.endAt,
                client: this.client,
                project: this.project,
                driver: this.driver,
                truck: this.truck,
                trailer: this.trailer,
                ticketNumber: this.ticketNumber,
            }, value => value !== null);

            this.$emit('change', filters);
        },
    },

    watch: {
        name() {
            this.handleChange();
        },
        status() {
            this.handleChange();
        },
        startAt() {
            this.handleChange();
        },
        endAt() {
            this.handleChange();
        },
        client() {
            this.handleChange();
        },
        project() {
            this.handleChange();
        },
        driver() {
            this.handleChange();
        },
        truck() {
            this.handleChange();
        },
        trailer() {
            this.handleChange();
        },
        ticketNumber() {
            this.handleChange();
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.DashboardFilterHeader {
    .Card {
        display: flex;
        flex-direction: column;
        padding: $admin-gutter;
        margin-bottom: $grid-gutter-width * 2;

        .row {
            display: flex;

            .FormInput.FormInputContainer {
                max-width: 100%;
            }

            &:not(:last-child) {
                margin-bottom: $grid-gutter-width;
            }

            .FormInputContainer {
                margin-bottom: 0;
            }

            & > div {
                flex: 1;
                margin-bottom: 0;
                max-width: 205px;

                &:not(:last-child) {
                    margin-right: $grid-gutter-width;
                }
            }
        }
    }
}
</style>